import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom"
// Icons framework
import * as Icon from 'ubs-icons';
import UCustomScrollBar from 'ubs-framework/v2/UCustomScrollBar';
import UModal from 'ubs-framework/v2/UModal/NewUModal'
import UNoDataFound from 'ubs-framework/v2/UErrorPages/UNoDataFound';

import useSocket from "../../hooks/useSocket";
import {sendData} from "../../../../store/actions";
import {COLOR} from "ubs-framework/v2/common/constant";
import Time from "../../Time/time";
import LSkeleton from "ubs-framework/v2/skeleton/list-skeleton";
import Avatar from "../../avatar";
import UAvatar from "ubs-framework/v2/UAvatar";
import {getName, getThumbor} from "ubs-framework/v2/common/function";

const NotificationPopupList = (props) => {
    const history = useHistory();
    const DISPATCH = useDispatch();

    const _ORG_ID = useSelector(e => e.common.orgId);
    const _USERS = useSelector(e => e?.ats?.userObj || {});
    const _S3_BASE_URL = useSelector(e => e.common.S3_BASE_URL);
    const _CANDIDATES = useSelector(e => e?.ats?.candidateObj || {});
    const _NC = useSelector(e => e?.ats?.notificationCount);

    const [list, setList] = useState([]);
    const [activityTab, setActivityTab] = useState('all');
    const [showSkeleton, setShowSkeleton] = useState(true);


    const {on, off, refresh} = useSocket(res => {
        if (res && !res?.error && !res?.data?.error) {
            switch (res?.event) {
                case 'ats|notifications|list': {
                    const candidateIds = [...new Set((res?.data?.data || [])
                        .map(r => r?.payload?.candidateInfo?._id)
                        .filter(id => id && !_CANDIDATES?.[id]))];
                    if (candidateIds.length) DISPATCH({type: 'FIND_MASTER_DATA_LIST', payload: {findCandidateIdsList: candidateIds}});

                    if (res?.data?.currentPage === 1 && res?.data?.isPopup) {
                        setList(res?.data?.data ?? []);
                        setShowSkeleton(false);
                    }
                    break;
                }
                case 'atsUpdateNotificationCount': {
                    if (res?.data?.notification) {
                        const copyList = JSON.parse(JSON.stringify(list));
                        copyList.unshift(res?.data?.notification);
                        setList(copyList);
                    }
                    break;
                }
                case 'ats|notifications|read' : {
                    if (res?.data?.isReadAll) {
                        if (activityTab === 'unread') {
                            setList([]);
                        } else {
                            let allList = JSON.parse(JSON.stringify(list));
                            allList.map(e => {
                                e.isRead = true
                                return e
                            })
                            setList(allList);
                        }
                    }
                    break;
                }
            }
        }
    })

    useEffect(() => {
        refresh();
        return () => off();
    }, [list]);

    useEffect(() => {
        sendData('ats|notifications|list', {limit: 20, currentPage: 1, isPopup: true});
    }, []);

    const notification = {
        readAll: () => {
            if (list.length !== 0) {
                sendData('ats|notifications|read', {isReadAll: true})
                if (activityTab === 'unread') setList([]);
            }
        },
        viewAllL: () => {
            history.push(`/${_ORG_ID}/notifications`)
            props?.setOpenNotification(false);
        },
        view: (item) => {
            const { isRead, _id, link, type, payload } = item;
            if (!isRead) sendData('ats|notifications|read', { notificationIdArr: [_id] });
            if (link) {
                window.open(link, '_blank');
            } else if (type?.toLowerCase() === 'mention') {
                const p = payload || {};
                const targetUserId = p?.userId || p?.userInfo?._id || p?.user?._id || p?.user;
                if (p?.mentionType === 1015) { // ONBOARDING
                    const path = p?._id === targetUserId ? 'employee-list' : 'employees';
                    window.open(`${process.env.REACT_APP_HRMS_MODULE_URL}/${_ORG_ID}/onboarding/${path}/${targetUserId}?referenceId=${p?._id}&userId=${targetUserId}`, '_blank');
                } else if (p?.mentionType === 1051) { // ATS_REQUISITION
                    window.open(`/${_ORG_ID}/requisitions/view/${p?._id}`, '_blank');
                } else if (p?.mentionType === 1016) { // ATS_CANDIDATE
                    window.open(`/${_ORG_ID}/candidates/details/${p?._id}/conversation`, '_blank');
                }
            }
        },
        tab: e => {
            setActivityTab(e);
            if (e === "all") {
                setShowSkeleton(true)
                sendData('ats|notifications|list', {limit: 20, currentPage: 1, isPopup: true})
            } else if (e === "unread") {
                setShowSkeleton(true)
                sendData('ats|notifications|list', {limit: 20, currentPage: 1, isRead: false, isPopup: true})
            }
        },
        close: () => {
            if (props?.openNotification) {
                props?.setOpenNotification(false);
            }
        }
    }

    return (
        <React.Fragment>
            <UModal
                open={props?.openNotification}
                header={'Notifications'}
                maxWidth={450}
                position='right'
                className="u_project-details"
                onClose={notification.close}
            >
                <div className="u_notification">
                    <div className="u_notification-top">
                        <div className="u_notification-btn u_flex u_align-center u_content-between">
                            <div className="u_flex u_align-center u_pt-12">
                                <span className={`u_notification-btn-inner u_flex u_align-center u_content-center u_sn ${activityTab === 'all' && 'u_active u_event-none'}`}
                                      onClick={() => notification.tab('all')}><span>All</span>
                                </span>
                                <span className={`u_notification-btn-inner u_flex u_align-center u_content-center u_sn ${activityTab === 'unread' && 'u_active u_event-none'}`}
                                      onClick={() => notification.tab('unread')}><span>Unread</span>
                                </span>
                            </div>
                            <p className={`${!_NC ? 'u_notification-disabled' : ''}`} onClick={notification.readAll}><span className="u_pr-5 u_flex"><Icon.DoubleTick size={14} fill={COLOR.u_green}/></span>Mark all as read</p>
                        </div>
                    </div>
                    <div className="u_notification-footer u_flex u_align-center u_content-between">
                        <h6 className="u_pl-10">New</h6>
                        <p onClick={notification.viewAllL}>View All<span className="u_pl-5 u_flex"><Icon.SortRightArrow size={14} fill={COLOR.u_blue}/></span></p>
                    </div>
                    <UCustomScrollBar>
                        <div className="u_notification-inner u_h-full">
                            <ul className="u_h-full">
                                {showSkeleton
                                    ? <LSkeleton /> :
                                    list && list?.length !== 0 ? list?.map(data => {
                                        return <li className={`u_cp ${!data?.isRead ? 'u_unread' : ''}`} key={data?._id} onClick={() => notification.view(data)}>
                                            {!(data?.referenceType === "jobExpire" && data?.type === "jobExpire") && (
                                                (["applyCandidate"].includes(data?.type) || data?.from === data?.payload?.candidateInfo?._id || data?.from === data?.payload?.otherUsers?._id || data?.payload?.candidateInfo?.isInterviewFormSubmit || data?.payload?.isInterviewFormSubmit) ? (
                                                    <UAvatar name={data?.payload?.otherUsers?.email
                                                        || getName(data?.payload?.isInterviewFormSubmit ? data?.payload : data?.payload?.candidateInfo)}
                                                        image={_CANDIDATES?.[data?.payload?.candidateInfo?._id]?.profileImage?.url}
                                                        width={30} s3Url={_S3_BASE_URL} thumbor={getThumbor()} />
                                                ) : (
                                                    <Avatar user={_USERS[data?.from]} width={30} />
                                                )
                                            )}

                                                <div className="u_notification-title u_notification-block">
                                                    <h3>
                                                        {(data?.referenceType === "jobExpire" && data?.type === "jobExpire")
                                                                ? "System Generated"
                                                                : (
                                                                    (["applyCandidate"].includes(data?.type) ||
                                                                        data?.from === data?.payload?.candidateInfo?._id ||
                                                                        data?.from === data?.payload?.otherUsers?._id ||
                                                                        data?.payload?.candidateInfo?.isInterviewFormSubmit ||
                                                                        data?.payload?.isInterviewFormSubmit)
                                                                        ? (
                                                                            // otherUsers is `{}` on non-public signs, so check the email itself
                                                                            data?.payload?.otherUsers?.email
                                                                                || getName(data?.payload?.isInterviewFormSubmit ? data?.payload : data?.payload?.candidateInfo)
                                                                        )
                                                                        : (
                                                                            _USERS[data?.from]?.name ?? "-"
                                                                        )
                                                                )
                                                        }

                                                        <span> {`${data?.title?.split(':')[0]} ${data?.title?.includes(":") ? ":" : ""}`} </span>

                                                        <a href={data?.link} target='_blank' className="u_color-blue" onClick={() => notification.view(data)}>{data?.title?.split(':')[1]}</a>

                                                    </h3>
                                                    <div className='u_ib u_pt-3'><Time createdAt={data?.createdAt}/></div>
                                                </div>
                                        </li>
                                    })
                                    :<div className="u_flex u_align-center u_content-center u_h-full">
                                        <UNoDataFound message="No new notification" image="/images/no-new-notification.svg"/></div>
                                }
                            </ul>
                        </div>
                    </UCustomScrollBar>
                </div>
            </UModal>
        </React.Fragment>
    );
}

export default NotificationPopupList;
